<!-- <h1>{{"SECTIONS.COOKIES_POLICY" | translate}}</h1>
<p>Ahora mismo solo usamos cookies tecnicas</p> -->

<form [formGroup]="cookies" (ngSubmit)="saveCookiesSettings()">


  <ion-grid class="cookies-configurator">

    <ion-row class="table-header">
      <ion-col class="toggle">

      </ion-col>
      <ion-col class="purpose">
        {{"COOKIES.PURPOSE" | translate}}
      </ion-col>
      <ion-col class="cookies">
        {{"COOKIES.COOKIES" | translate}}
      </ion-col>


    </ion-row>


    <!-- TECHNICAL -->
    <ion-row class="table-body">
      <ion-col class="toggle">
        <ion-toggle checked disabled formControlName="technical" mode="ios"></ion-toggle>
      </ion-col>
      <ion-col class="purpose">
        <p><strong>{{"COOKIES.TECHNICAL_COOKIES" | translate}}</strong></p>
        <p>{{"COOKIES.TECHNICAL_COOKIES_DESC" | translate}}</p>
      </ion-col>


      <ion-col class="cookie-data">
        <ion-row>
          <ion-col class="type">
            {{"COOKIES.TECHNICAL" | translate}}
          </ion-col>
          <ion-col class="cookies">
            merlin_cookies
          </ion-col>
          <ion-col class="owner">
            {{"COOKIES.WEB_OWNER" | translate}}
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.1_YEAR" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.TECHNICAL" | translate}}
          </ion-col>
          <ion-col class="cookies">
            [merlin-web] coords
          </ion-col>
          <ion-col class="owner">
            {{"COOKIES.WEB_OWNER" | translate}}
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.NO_EXPIRATION" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.TECHNICAL" | translate}}
          </ion-col>
          <ion-col class="cookies">
            [merlin-web] situmToken
          </ion-col>
          <ion-col class="owner">
            {{"COOKIES.WEB_OWNER" | translate}}
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.NO_EXPIRATION" | translate}}
          </ion-col>
        </ion-row>

      </ion-col>
    </ion-row>


    <!-- PREFERENCES -->
    <!-- <ion-row class="table-body">
      <ion-col class="toggle">
        <ion-toggle formControlName="preferences" mode="ios"></ion-toggle>
      </ion-col>
      <ion-col class="purpose">
        <p><strong>{{"COOKIES.PREFERENCES_COOKIES" | translate}}</strong></p>
        <p>{{"COOKIES.PREFERENCES_COOKIES_DESC" | translate}}</p>
      </ion-col>
      <ion-col class="cookie-data">
        <ion-row>
          <ion-col class="type">
            {{"COOKIES.TECHNICAL" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>_Cookies</p>
          </ion-col>
          <ion-col class="owner">
            {{"COOKIES.WEB_OWNER" | translate}}
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.1_YEAR" | translate}}
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row> -->

    <!-- ANALYTICS -->
    <ion-row class="table-body">
      <ion-col class="toggle">
        <ion-toggle formControlName="analytics" mode="ios"></ion-toggle>
      </ion-col>
      <ion-col class="purpose">
        <p><strong>{{"COOKIES.ANALYTICS_COOKIES" | translate}}</strong></p>
        <p>{{"COOKIES.ANALYTICS_COOKIES_DESC" | translate}}</p>
      </ion-col>
      <ion-col class="cookie-data">

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.ANALYTICS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>__sharethis_cookie_test__</p>
          </ion-col>
          <ion-col class="owner">
            ShareThis
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.9_MONTHS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.ANALYTICS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>__unam</p>
          </ion-col>
          <ion-col class="owner">
            ShareThis
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.10_MONTHS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.ANALYTICS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>_gat</p>
          </ion-col>
          <ion-col class="owner">
            Google Analytics
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.10_MINUTES" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.ANALYTICS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>_ga</p>
          </ion-col>
          <ion-col class="owner">
            Google Analytics
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.2_YEARS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="type">
            {{"COOKIES.ANALYTICS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>_gid</p>
          </ion-col>
          <ion-col class="owner">
            Google Analytics
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.24_HOURS" | translate}}
          </ion-col>
        </ion-row>

      </ion-col>
    </ion-row>

    <!-- ADS -->
    <ion-row class="table-body">
      <ion-col class="toggle">
        <ion-toggle formControlName="ads" mode="ios"></ion-toggle>
      </ion-col>
      <ion-col class="purpose">
        <p><strong>{{"COOKIES.ADS_COOKIES" | translate}}</strong></p>
        <p>{{"COOKIES.ADS_COOKIES_DESC" | translate}}</p>
      </ion-col>

      <ion-col class="cookie-data">
        <!-- <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>SID, SAPISID, APISID, SSID, HSID, NID, PREF, 1P_JAR</p>
          </ion-col>
          <ion-col class="owner">
            Google
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.10_YEARS" | translate}}, {{"COOKIES.MAY_EXPIRE_SOONER" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>SIDCC</p>
          </ion-col>
          <ion-col class="owner">
            Google
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.3_MONTHS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>CONSENT</p>
          </ion-col>
          <ion-col class="owner">
            Google
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>PLl_language </p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.90_DAYS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>XS</p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.90_DAYS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>DATR</p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.2_YEARS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>SB</p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.2_YEARS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>C_USER</p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.20_DAYS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>FR</p>
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.90_DAYS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>IDE</p>
          </ion-col>
          <ion-col class="owner">
            DoubleClick
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.2_YEARS" | translate}}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="cookies">
            <p>__stid</p>
          </ion-col>
          <ion-col class="owner">
            ShareThis
          </ion-col>
          <ion-col class="duration">
            {{"COOKIES.PERSISTENT" | translate}},
            {{"COOKIES.1_YEAR" | translate}}
          </ion-col>
        </ion-row> -->


        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Adform
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://site.adform.com/privacy-center/adform-cookies/">https://site.adform.com/privacy-center/adform-cookies/</a>
            </p>
            <p>
              <a target="_blank"
                href="https://site.adform.com/privacy-center/website-privacy/website-cookie-policy/">https://site.adform.com/privacy-center/website-privacy/website-cookie-policy/</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Google
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://policies.google.com/technologies/cookies?hl=es">https://policies.google.com/technologies/cookies?hl=es</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Facebook
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://www.facebook.com/policies/cookies/">https://www.facebook.com/policies/cookies/</a>
            </p>
          </ion-col>
        </ion-row>


        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Xandr
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://www.xandr.com/privacy/cookie-policy/">https://www.xandr.com/privacy/cookie-policy/</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Linkedin
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://es.linkedin.com/legal/cookie-policy">https://es.linkedin.com/legal/cookie-policy</a>
            </p>
            <p>
              <a target="_blank"
                href="https://es.linkedin.com/legal/l/cookie-table">https://es.linkedin.com/legal/l/cookie-table</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Linkedin
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://es.linkedin.com/legal/cookie-policy">https://es.linkedin.com/legal/cookie-policy</a>
            </p>
            <p>
              <a target="_blank"
                href="https://es.linkedin.com/legal/l/cookie-table">https://es.linkedin.com/legal/l/cookie-table</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Amazon
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://www.amazon.es/gp/help/customer/display.html/?nodeId=201909150">https://www.amazon.es/gp/help/customer/display.html/?nodeId=201909150</a>
            </p>
            <p>
              <a target="_blank"
                href="https://www.amazon.es/cookieprefs?ref_=cookies_notice_cpp">https://www.amazon.es/cookieprefs?ref_=cookies_notice_cpp</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Pinterest
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://policy.pinterest.com/es/cookies">https://policy.pinterest.com/es/cookies</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Tik Tok
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://www.tiktok.com/legal/cookie-policy?lang=es">https://www.tiktok.com/legal/cookie-policy?lang=es</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Spotify
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank"
                href="https://www.spotify.com/es/legal/cookies-policy/">https://www.spotify.com/es/legal/cookies-policy/</a>
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="owner">
            {{"COOKIES.ADS" | translate}}
          </ion-col>
          <ion-col class="owner">
            Teads
          </ion-col>
          <ion-col size="6" class="links">
            <p>
              <a target="_blank" href="https://www.teads.com/privacy-policy/">https://www.teads.com/privacy-policy/</a>
            </p>
          </ion-col>
        </ion-row>

      </ion-col>

    </ion-row>

    <ion-row class="footer">

      <ion-button (click)="saveAll()">
        {{"COOKIES.ACCEPT" |translate}}
      </ion-button>

      <ion-button type="submit">
        {{"COOKIES.SAVE" |translate}}
      </ion-button>

      <!-- <ion-button (click)="rejectAll()">
        {{"COOKIES.REJECT_ALL" |translate}}
      </ion-button> -->


    </ion-row>

  </ion-grid>
</form>